import type { ReactElement } from 'react';

import type { AppUrlParams, EventPhoto } from '../../../../types';
import { Card } from '@fastnorth/react-cerberus/Card';
import { Link, useParams } from 'react-router-dom';
import './GroupPreview.scss';
import ThumbnailList from '../thumbnail/ThumbnailList';
import { useTranslation } from 'react-i18next';

type GroupPreviewProps = {
  id: string;
  name: string;
  photos: EventPhoto[];
};

const GroupPreview = ({ id, name, photos }: GroupPreviewProps): ReactElement => {
  const { galleryId, locale } = useParams<AppUrlParams>();
  const { t } = useTranslation();

  return (
    <Card className={'mb-3'}>
      <Card.Header className={'group-preview__header pb-0'}>
        <h2 className={'h4'}>{name}</h2>
        <Link
          className={'group-preview__header-link'}
          to={{ pathname: `/${locale}/galleries/${galleryId}/groups/${id}` }}>
          {t('photos_ui.view_all')} <span className={'fa fa-arrow-right'}></span>
        </Link>
      </Card.Header>
      <Card.Body>
        <ThumbnailList photos={photos} relativeRoutePrefix={`groups/${id}`} />
      </Card.Body>
    </Card>
  );
};

export default GroupPreview;
